import { SrcType } from './shared/model/docavea-viewer-interface';

// visiodocs-app#753: the viewer takes a LOAD_PDF while an earlier load still resolves (between pagesinit and pagesloaded,
// and during a SET_REDACTION_MODE or SET_ORIENTATIONS reload). Each load takes a number when it starts; only the load
// started last may set its document, finish pagesinit or send PDF_LOADED, so an earlier file that resolves late never
// wins the screen.
export class LatestLoad {
    private count = 0;

    start(): number {
        return ++this.count;
    }

    isLatest(load: number): boolean {
        return load === this.count;
    }
}

// PDF_LOADED names the URL the viewer shows, so the app can send its file again when another one won. Written as a literal
// rather than the app's PdfLoadedPayload: src/shared is the main checkout's, which has the type only once visiodocs-app#753
// merges. A load from file data sends no src.
export function pdfLoadedPayload(srcType: SrcType, src: unknown): { src?: string } {
    return srcType === SrcType.URL && typeof src === 'string' ? { src } : {};
}
